module.exports = __webpack_public_path__ + "static/media/TIME-on.ecc15ecd.svg";